/* global Localize */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  Form,
  Segment,
  Header,
  Container,
  Checkbox,
  Icon,
  Dropdown,
  Modal,
  Grid,
  Divider,
  List,
} from "semantic-ui-react";
import Input from "components/InputForm";
import PassordInputWithCapsLockIndicator from "../../components/PassordInputWithCapsLockIndicator";
import MosaicLoader from "../../components/MosaicLoader";
import {
  supplierLogin,
  setLanguage,
  supplierLoginWithToken,
} from "store/actions/app";
import LogoImg from "../../images/iconWhite.png";
import backgroundLogin from "../../images/backgroundLogin.png";
import backgroundLoginMovil from "../../images/backgroundMovil.png";
import { validateLogoToken } from "store/actions/sys_companys";
import { useWindowDimensions } from "semantic-table/dist/components/WindowSize";
import { useTranslation } from "react-i18next";

const SupplierLogin = (props) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [openModalPassword, setOpenModalPassword] = useState(false);
  const [logoToken, setLogoToken] = useState(null);
  const { width } = useWindowDimensions();
  const [logoUrl, setLogoUrl] = useState(null);
  const logoImageUrl = logoToken ? logoUrl : LogoImg;

  const [user, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const token = q.get("access_token");

    if (!token) return;

    (async () => {
      try {
        setLoading(true);
        await props.supplierLoginWithToken({
          supplier_token: token,
          nonUnique: true,
        });

        const cleanUrl =
          window.location.pathname +
          window.location.search
            .replace(/([?&])access_token=[^&]+(&?)/, (m, sep, tail) =>
              tail ? sep : "",
            )
            .replace(/([?&])role=[^&]+(&?)/, (m, sep, tail) =>
              tail ? sep : "",
            )
            .replace(/([?&])impersonated=[^&]+(&?)/, (m, sep, tail) =>
              tail ? sep : "",
            )
            .replace(/([?&])redirect=[^&]+(&?)/, (m, sep, tail) =>
              tail ? sep : "",
            )
            .replace(/[?&]$/, "");
        window.history.replaceState({}, "", cleanUrl);
      } catch (e) {
        localStorage.setItem(
          "@flash",
          JSON.stringify({
            type: "error",
            text: t('No fue posible iniciar sesión con el token.'),
          }),
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [props.supplierLoginWithToken, props.history]);

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("e");

      if (token) {
        setLogoToken(token);
        try {
          const logoUrl = await props.validateLogoToken(token);
          console.log("Logo URL in LoginRoute:", logoUrl);
          setLogoUrl(logoUrl);
        } catch (error) {
          console.error("Error validating logo token:", error.message);
        }
      }
    };

    if (typeof Localize !== "undefined" && Localize.showWidget) {
      Localize.showWidget();
    }

    fetchData();
  }, [props]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await props.supplierLogin({ user, password });
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    background: isMobile
      ? `url(${backgroundLoginMovil})`
      : `url(${backgroundLogin})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
  };

  return (
    <div style={containerStyle}>
      {/* Right Section */}
      <Container
        style={{
          flex: isMobile ? "none" : 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? "1rem" : "2rem",
          minHeight: isMobile ? "auto" : "100vh",
        }}
      >
        <Segment
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(8px)",
            padding: isMobile ? "1.5rem" : "2rem",
            width: "100%",
            maxWidth: "400px",
          }}
        >
          {(process.env.REACT_APP_LOGO_LOGIN_URL ?? logoImageUrl) && (
            <div style={{ textAlign: "center", marginBottom: "1rem" }}>
              <img
                src={process.env.REACT_APP_LOGO_LOGIN_URL ?? logoImageUrl}
                alt="Logo"
                style={{
                  maxWidth: "120px",
                  filter: "drop-shadow(1px 1px 2rem white)",
                }}
              />
            </div>
          )}
          <Header
            as="h2"
            style={{
              color: "white",
              marginBottom: "2rem",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <Container
              textAlign="center"
              style={{ marginTop: "2rem", color: "white" }}
            >

              {t('Sitio del Proveedor')}
            </Container>
          </Header>
          <Form size="large" onSubmit={handleSubmit}>
            <Form.Field>
              <Form.Input
                fluid
                type="email"
                value={user}
                icon={<Icon name="user" style={{ color: "gray" }} />}
                iconPosition="left"
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('Correo electrónico')}
              />
            </Form.Field>
            <PassordInputWithCapsLockIndicator
              password={password}
              onChange={(value) => setPassword(value)}
            />
            <Button
              fluid
              primary
              type="submit"
              disabled={loading}
              style={{ marginBottom: "1rem" }}
            >
              {loading ? (
                <MosaicLoader size={18} />
              ) : (
                t('Iniciar Sesión')
              )}
            </Button>
          </Form>
          <Container
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Button
              icon="question"
              circular
              color="black"
              type="button"
              onClick={() => {
                setOpenModal(!openModal);
              }}
            />
          </Container>
        </Segment>
      </Container>
      <Modal
        closeIcon
        basic
        centered={true}
        onClose={() => setOpenModal(false)}
        onOpen={() => setOpenModal(true)}
        open={openModal}
        size="large"
      >
        <Modal.Content>
          <Segment inverted style={{ height: "100%" }}>
            <Grid stackable divided inverted>
              <Grid.Row columns={2}>
                <Grid.Column
                  width={6}
                  verticalAlign="middle"
                  textAlign="center"
                >
                  <Header inverted content="© Geologistic GPS 2025" />
                </Grid.Column>
                <Grid.Column width={8}>
                  <Header inverted content={t('Contacto')} />
                  <Divider></Divider>
                  <Header
                    size="small"
                    inverted
                    content={t('¿Necesitas registrar un nuevo ticket o solicitud?')}
                  />
                  <List divided inverted>
                    <List.Item
                      header={t('Ingresa al Portal: ')}
                      content="https://geologistic.com.mx/Soporte/"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(
                          "https://geologistic.com.mx/Soporte/",
                          "_blank",
                        );
                      }}
                    />
                    <List.Item
                      header={t('Soporte')}
                      content="(686) 214 5447, (686) 385 6938,  (686) 510 9915"
                    />
                    <List.Item header={t('Oficina')} content="(686) 372 9877" />
                    <List.Item
                      header={t('Emergencias')}
                      content="(686) 420 3333, (686) 214 5447, (686) 385 6938, (686) 510 9915,  (686) 123 6454"
                    />
                    <List.Item
                      header={t('Administración')}
                      content="(686) 122 0316"
                    />
                    <List.Item
                      header={t('Ventas')}
                      content="(686) 510 9915, (686) 196 4736, (686) 420 8586,  (686) 191 1571"
                    />
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Modal.Content>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.app?.lang,
});

const mapDispatchToProps = (dispatch) => ({
  supplierLogin: (parmas) => dispatch(supplierLogin(parmas)),
  supplierLoginWithToken: (parmas) => dispatch(supplierLoginWithToken(parmas)),
  validateLogoToken: (logoToken) => dispatch(validateLogoToken(logoToken)),
  setLanguage: (lang) => dispatch(setLanguage(lang)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupplierLogin);
